var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.09375 8C2.09375 11.2619 4.73807 13.9062 8 13.9062C11.2619 13.9062 13.9062 11.2619 13.9062 8C13.9062 4.73807 11.2619 2.09375 8 2.09375C4.73807 2.09375 2.09375 4.73807 2.09375 8Z",
    stroke: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3125 -0.0625L-2.3125 -0.0625L-2.3125 16.625L18.3125 16.625L18.3125 -0.0625Z",
    fill: "#E80012"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.625 -0.0625H-2.3125L-2.3125 16.625H7.625L7.625 -0.0625Z",
    fill: "#E80012"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1875 -1.375H5.1875L5.1875 16.625H11.1875L11.1875 -1.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.125 6.6875V8.41888L9.12004 8.41904C9.06889 8.9206 8.62893 9.3125 8.09375 9.3125C7.55857 9.3125 7.11861 8.9206 7.06746 8.41904L7.0625 8.41888V6.6875H9.125Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83403 8.27921L8.83448 8.29324C8.83448 8.68652 8.50283 9.00534 8.09372 9.00534C7.68461 9.00534 7.35297 8.68652 7.35297 8.29324C7.35297 8.28855 7.35301 8.28387 7.35311 8.27921H8.83403Z",
    fill: "#E80012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9049 7.05054H7.35297V8.00001H7.9049V7.05054Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83453 7.05054H8.28259V8.00001H8.83453V7.05054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0625 7.84297C10.0625 8.96522 9.18106 9.87498 8.09375 9.87498C7.00644 9.87498 6.125 8.96522 6.125 7.84297C6.125 7.11994 6.49088 6.4851 7.04197 6.12494L7.04192 6.57376C6.69528 6.88008 6.4756 7.33505 6.4756 7.84297C6.4756 8.76537 7.20007 9.51312 8.09375 9.51312C8.98743 9.51312 9.7119 8.76537 9.7119 7.84297C9.7119 7.33505 9.49222 6.88008 9.14558 6.57376L9.14553 6.12494C9.69662 6.4851 10.0625 7.11994 10.0625 7.84297Z",
    fill: "#1CC83C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerSm);
export default __webpack_public_path__ + "static/media/PER-SM.71e46150cb158a7de89de29d8d100e1c.svg";
export { ForwardRef as ReactComponent };